import { colors } from '@constants/colors';
import { ScreenSizes } from '@interfaces';
import { useTheme } from '@mui/material';
import { useMytaverse } from '@providers/MytaverseProvider';

export const useStyles = () => {
  const { breakpoints } = useTheme();
  const { appTheme } = useMytaverse();

  const titleColor = appTheme.loginPage.assets.titleColor;
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      flex: 1,
      minHeight: 0,
      paddingTop: 3,
      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        paddingTop: 2,
      },
    },
    content: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      minHeight: 0,
    },
    title: {
      fontFamily: 'var(--primary-font-bold)',
      fontSize: 40,
      lineHeight: 1.1,
      color: titleColor,
      marginBottom: 1,
      [breakpoints.down(ScreenSizes.PcLarge)]: {
        fontSize: 32,
        '& span': {
          display: 'block',
        },
      },
      [breakpoints.down(ScreenSizes.Tablet)]: {
        fontSize: 22,
        lineHeight: '26px',
      },
    },
    children: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      overflow: 'auto',
      width: 'calc(100% + 5px)',
      paddingRight: '5px',

      '&::-webkit-scrollbar': {
        height: '5px',
        width: '5px',
      },

      '&::-webkit-scrollbar-track': {
        backgroundColor: colors.silver,
        borderRadius: '2px',
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: appTheme.mainColor,
        borderRadius: '2px',
        boxShadow: 'unset',
      },
    },
    bottomElement: {
      marginTop: '20px',
      [breakpoints.down(ScreenSizes.Tablet)]: {
        marginTop: '15px',
      },
    },
  };
};
